<template>
    <div class="bg-color-granite pb-10">
		<div class="d-flex justify-center align-center w-100 position-relative">
			<v-img class="w-100 h-100"			
				:height="199"
				aspect-ratio="16/9"
				src="https://dellpartnerincentives.com/siteassets/Images/HomePartner/Banner/bgRISE2.jpg"
			></v-img>
			<div class="position-absolute page-header">
				<h1><LanguagePlaceholder default-text="Rewards Calculator" /></h1>
			</div>			
		</div>
        <div class="bg-color-granite w-100 h-100">
            <div class="bg-color-quartz w-100 h-100 my-2">
                <v-row no-gutters class="d-flex justify-center w-100 pa-0 pt-3 bg-color-teal-900 tx-color-white">
                    <v-col cols="10" class="d-flex flex-column justify-start w-100 pa-0 py-8 tx-font-normal tx-font-size20">  
                        <v-row class="mb-2">
                            <LanguagePlaceholder is-html
                                default-text="Calculate how much your Partners could earn this incentive period. Simply enter the number of units they intend to purchase below and see how many USD rewards they could earn." />
                        </v-row>             
                    </v-col>
                </v-row>
            </div>
            <div class="bg-color-granite w-auto h-100 my-2 mx-10" id="summary">
                <v-row no-gutters class="d-flex justify-center w-100 pa-0">
                    <v-col cols="1" class="bg-color-quartz"></v-col>
                    <v-col cols="10" class="d-flex justify-start w-100 pa-0 pt-10 pb-5 ps-10 tx-font-bold bg-color-quartz">  
                        <h1>
                            <LanguagePlaceholder default-text='Rewards Calculator Summary'></LanguagePlaceholder>
                        </h1>   
                    </v-col>
                    <v-col cols="1" class="bg-color-quartz"></v-col>
                    </v-row>
                    <v-row no-gutters class="d-flex justify-center w-100 pa-0 bg-color-quartz">
                    <v-col cols="1" class="bg-color-quartz"></v-col>
                    <v-col cols="10" class="bg-color-white d-flex justify-center flex-column w-100 pa-0 my-5 tx-font-bold tx-font-size14">  
                        <v-row class="d-flex flex-column ma-5 px-5">
                            <v-row class="d-flex justify-center flex-row mt-2" style="height: 50px;">
                                <v-col class="bg-color-teal-900 tx-color-glacier">
                                </v-col>
                                <v-col class="bg-color-teal-900 tx-color-glacier">
                                    <LanguagePlaceholder default-text="PCs+ Displays+Peripherals" />
                                </v-col>
                                <v-col class="bg-color-teal-900 tx-color-glacier">
                                    <LanguagePlaceholder default-text="SERVER+" />
                                </v-col>
                                <v-col class="bg-color-teal-900 tx-color-glacier">
                                    <LanguagePlaceholder default-text="STORAGE+" />
                                </v-col>   
                            </v-row>    
                            <v-row class="d-flex justify-center flex-row" style="height: 50px;">
                                <v-col class="bg-color-teal-900 tx-color-glacier">
                                    <LanguagePlaceholder default-text="Units" />
                                </v-col>
                                <v-col class="bg-color-titanium tx-color-teal-900">
                                    <div>{{ pdpUnits }}</div>
                                </v-col>
                                <v-col class="bg-color-teal-600 tx-color-glacier">
                                    <div>{{ serverUnits }}</div>
                                </v-col>
                                <v-col class="bg-color-teal-700 tx-color-glacier">
                                    <div>{{ storageUnits }}</div>
                                </v-col>   
                            </v-row>  
                            <v-row class="d-flex justify-center flex-row" style="height: 50px;">
                                <v-col class="bg-color-teal-900 tx-color-glacier">
                                    <LanguagePlaceholder default-text="Units Toward Multiplier" />
                                </v-col>
                                <v-col class="bg-color-titanium tx-color-teal-900">
                                    <div>{{ pdpMultiplierUnits }}</div>
                                </v-col>
                                <v-col class="bg-color-teal-600 tx-color-glacier">
                                    <div>{{ serverMultiplierUnits }}</div>
                                </v-col>
                                <v-col class="bg-color-teal-700 tx-color-glacier">
                                   <div>{{ storageMultiplierUnits }}</div>
                                </v-col>   
                            </v-row>  
                            <v-row class="d-flex justify-center flex-row" style="height: 50px;">
                                <v-col class="bg-color-teal-900 tx-color-glacier">
                                    <LanguagePlaceholder default-text="Multiplier Achieved" />
                                </v-col>
                                <v-col class="bg-color-titanium tx-color-teal-900">
                                    <div>{{ pdpmultiplier }}x Rewards</div>
                                </v-col>
                                <v-col class="bg-color-teal-600 tx-color-glacier">
                                    <div>{{ serverMultiplier }}x Rewards</div>
                                </v-col>
                                <v-col class="bg-color-teal-700 tx-color-glacier">
                                   <div>{{ storageMultiplier }}x Rewards</div>
                                </v-col>   
                            </v-row>  
                            <v-row class="d-flex justify-center flex-row" style="height: 50px;">
                                <v-col class="bg-color-teal-900 tx-color-glacier">
                                    <LanguagePlaceholder default-text="$ (USD) Earned" />
                                </v-col>
                                <v-col class="bg-color-titanium tx-color-teal-900">
                                    <div>{{ $filters.currencyUSD(pdpUsdReward) }}</div>
                                </v-col>
                                <v-col class="bg-color-teal-600 tx-color-glacier">
                                    <div>{{ $filters.currencyUSD(serverUsdReward) }}</div>
                                </v-col>
                                <v-col class="bg-color-teal-700 tx-color-glacier">
                                    <div>{{ $filters.currencyUSD(storageUsdReward) }}</div>
                                </v-col>   
                            </v-row>  
                            <v-row class="d-flex justify-center flex-row" style="height: 50px;">
                                <v-col class="bg-color-teal-900 tx-color-glacier">
                                    <LanguagePlaceholder default-text="Total $ (USD) Earned With Multiplier" />
                                </v-col>
                                <v-col class="bg-color-titanium tx-color-teal-900">
                                    <div>{{ $filters.currencyUSD(pdpUsdRewardWithMultiplier) }}</div>
                                </v-col>
                                <v-col class="bg-color-teal-600 tx-color-glacier">
                                    <div>{{ $filters.currencyUSD(serverUsdRewardWithMultiplier) }}</div>
                                </v-col>
                                <v-col class="bg-color-teal-700 tx-color-glacier">
                                    <div>{{ $filters.currencyUSD(storageUsdRewardWithMultiplier) }}</div>
                                </v-col>   
                            </v-row>  
                            <v-row class="d-flex justify-center flex-row" style="height: 50px;">
                                <v-col cols="3" class="bg-color-teal-900 tx-color-glacier">
                                    <LanguagePlaceholder default-text="Grand Total $ (USD) Earned Without Multiplier" />
                                </v-col>
                                <v-col cols="3" class="bg-color-titanium tx-color-teal-900">
                                    <div>{{ $filters.currencyUSD(totalUsdRewardWithoutMulpiplier) }}</div>
                                </v-col>
                                <v-col cols="6" class="bg-color-teal-900 tx-color-white">
                                    <LanguagePlaceholder is-html
                                        default-text="Use this download summary to help guide and motivate your Partners to keep purchasing, so they can reach their multiplier thresholds and maximise their rewards!" />
                                </v-col>
                            </v-row>  
                            <v-row class="d-flex justify-center flex-row" style="height: 50px;">
                                <v-col cols="3" class="bg-color-teal-900 tx-color-glacier">
                                    <LanguagePlaceholder default-text="Grand Total $ (USD) Earned With Multiplier" />
                                </v-col>
                                <v-col cols="3" class="bg-color-titanium tx-color-teal-900">
                                    <div>{{ $filters.currencyUSD(totalUsdReward) }}</div>
                                </v-col>
                                <v-col cols="6" class="bg-color-teal-900 tx-color-navy">
                                    <v-btn @click="downloadSummary" variant="flat" class="mx-2" color="#00796B">
                                        <LanguagePlaceholder default-text="Download Summary" />
                                    </v-btn> 
                                </v-col>   
                            </v-row>  
                        </v-row>
                        <v-row class="d-flex flex-column ma-5">
                            <v-card class="elevation-0">
                                <template v-slot:text>
                                    <v-text-field v-if="screenshot === false" clearable v-model="searchProduct" 
                                        prepend-inner-icon="mdi-magnify" variant="outlined" hide-details single-line>
                                        <template v-slot:label>                                                            	
                                                    <LanguagePlaceholder is-html default-text="Search" />
                                                </template>

                                    </v-text-field>
                                </template>
                                <div class="pa-4">
                                    <v-expansion-panels v-model="panel" tile variant="accordion" multiple>
                                        <v-expansion-panel>
                                
                                            <v-expansion-panel-title color="#00897B">
                                                <LanguagePlaceholder default-text="PCS+ DISPLAYS+PERIPHERALS" />
                                            </v-expansion-panel-title>
                                    

                                            <v-expansion-panel-text class="no-padding innerExPan">
                                                <v-data-table :items-per-page="-1" hide-default-footer :headers="headers" class="v-data-table-row"
                                                    :items="displayItemsPC" item-key="id" :search="searchProduct">
                                                    <template v-slot:item.estimatedunits="{ item }">
                                                        <v-text-field @blur="calculateRewards" type="number" hide-details
                                                            title ="Estimated Units"
                                                            aria-label ="Estimated Units"
                                                            v-model="item.estimatedUnits" variant="outlined" class="my-1">

                                                        </v-text-field>
                                                    </template>
                                                    <template v-slot:item.counttowardsmultiplier="{ item }">
                                                        {{ item.countTowardsMultiplier === true ? 'Yes' : 'No' }}
                                                    </template>
                                                    <template v-slot:item.rewardsperbox="{ item }">
                                                        {{ $filters.currencyUSD(item.rewardsPerBox) }}
                                                    </template>
                                                </v-data-table>
                                            </v-expansion-panel-text>
                                        </v-expansion-panel>

                                        <v-expansion-panel>
                                
                                            <v-expansion-panel-title color="#00897B">
                                                <LanguagePlaceholder default-text="SERVER+" />
                                            </v-expansion-panel-title>
                                    

                                            <v-expansion-panel-text class="no-padding innerExPan">
                                                <v-data-table :items-per-page="-1" hide-default-footer :headers="headers" class="v-data-table-row"
                                                    :items="displayItemsSERVER" item-key="id" :search="searchProduct">
                                                    <template v-slot:item.estimatedunits="{ item }">
                                                        <v-text-field @blur="calculateRewards" type="number" hide-details
                                                            title ="Estimated Units"
                                                            aria-label ="Estimated Units"
                                                            v-model="item.estimatedUnits" variant="outlined" class="my-1">

                                                        </v-text-field>
                                                    </template>
                                                    <template v-slot:item.counttowardsmultiplier="{ item }">
                                                        {{ item.countTowardsMultiplier === true ? 'Yes' : 'No' }}
                                                    </template>
                                                    <template v-slot:item.rewardsperbox="{ item }">
                                                        {{ $filters.currencyUSD(item.rewardsPerBox) }}
                                                    </template>
                                                </v-data-table>
                                            </v-expansion-panel-text>
                                        </v-expansion-panel>

                                        <v-expansion-panel>
                                
                                            <v-expansion-panel-title color="#00897B">
                                                <LanguagePlaceholder default-text="STORAGE+" />
                                            </v-expansion-panel-title>
                                    

                                            <v-expansion-panel-text class="no-padding innerExPan">
                                                <v-data-table :items-per-page="-1" hide-default-footer :headers="headers" class="v-data-table-row"
                                                    :items="displayItemsSTORAGE" item-key="id" :search="searchProduct">
                                                    <template v-slot:item.estimatedunits="{ item }">
                                                        <v-text-field @blur="calculateRewards" type="number" hide-details
                                                            title ="Estimated Units"
                                                            aria-label ="Estimated Units"
                                                            v-model="item.estimatedUnits" variant="outlined" class="my-1">

                                                        </v-text-field>
                                                    </template>
                                                    <template v-slot:item.counttowardsmultiplier="{ item }">
                                                        {{ item.countTowardsMultiplier === true ? 'Yes' : 'No' }}
                                                    </template>
                                                    <template v-slot:item.rewardsperbox="{ item }">
                                                        {{ $filters.currencyUSD(item.rewardsPerBox) }}
                                                    </template>
                                                </v-data-table>
                                            </v-expansion-panel-text>
                                        </v-expansion-panel>

                                    </v-expansion-panels>                                    
                                </div>

                            </v-card>
                        </v-row>
                    </v-col>
                    <v-col cols="1" class="bg-color-quartz"></v-col>
                </v-row>
            </div>
        </div>
    </div>

</template>

<script setup>
import { ref, onMounted, computed } from 'vue'
import LanguagePlaceholder from '@/components/LanguagePlaceholder.vue'
import imgUrl_rewardsCalculator from '@/assets/img/banner/green_rewardscalculator.jpg'
import html2canvas from 'html2canvas';
import { useSystemStore } from '@/stores/system'


const systemStore = useSystemStore()

const eligibleProducts = ref({})
const searchProduct = ref('')
const calculated = ref(false)

const totalUnits = ref(0)
const totalUsdRewards = ref(0)
const totalUsdRewardWithoutMulpiplier = ref(0)

const pdpUnits = ref(0)
const pdpMultiplierUnits = ref(0)
const pdpmultiplier = ref(0)
const pdpUsdReward = ref(0)
const pdpUsdRewardWithMultiplier = ref(0)

const serverUnits = ref(0)
const serverMultiplierUnits = ref(0)
const serverMultiplier = ref(0)
const serverUsdReward = ref(0)
const serverUsdRewardWithMultiplier = ref(0)

const storageUnits = ref(0)
const storageMultiplierUnits = ref(0)
const storageMultiplier = ref(0)
const storageUsdReward = ref(0)
const storageUsdRewardWithMultiplier = ref(0)


const totalUsdReward = ref(0)
const screenshot = ref(false)
const panel = ref(0)

const displayItems = computed(() => {
    if (screenshot.value === true) {
        if (eligibleProducts.value.rewardsCalculatorProducts != undefined) {
            return eligibleProducts.value.rewardsCalculatorProducts.filter(product => {
                return Number(product.estimatedUnits) > 0
            })
        } else {
            return eligibleProducts.value.rewardsCalculatorProducts
        }

    } else {
        return eligibleProducts.value.rewardsCalculatorProducts
    }

})

const displayItemsPC = computed(() => {
    if (screenshot.value === true) {
        if (eligibleProducts.value.rewardsCalculatorProducts != undefined) {
            return eligibleProducts.value.rewardsCalculatorProducts.filter(product => {
                return Number(product.estimatedUnits) > 0 && product.section === 'PCs + Displays + Peripherals'
            })
        }
    } else {
        if (eligibleProducts.value.rewardsCalculatorProducts != undefined) {
            return eligibleProducts.value.rewardsCalculatorProducts.filter(product => {
                return product.section === 'PCs + Displays + Peripherals'
            })
        }
    }
})

const displayItemsSERVER = computed(() => {
    if (screenshot.value === true) {
        if (eligibleProducts.value.rewardsCalculatorProducts != undefined) {
            return eligibleProducts.value.rewardsCalculatorProducts.filter(product => {
                return Number(product.estimatedUnits) > 0 && product.section === 'Server+'
            })
        }
    } else {
        if (eligibleProducts.value.rewardsCalculatorProducts != undefined) {
            return eligibleProducts.value.rewardsCalculatorProducts.filter(product => {
                return product.section === 'Server+'
            })
        }
    }
})

const displayItemsSTORAGE = computed(() => {
    if (screenshot.value === true) {
        if (eligibleProducts.value.rewardsCalculatorProducts != undefined) {
            return eligibleProducts.value.rewardsCalculatorProducts.filter(product => {
                return Number(product.estimatedUnits) > 0 && product.section === 'Storage+'
            })
        }
    } else {
        if (eligibleProducts.value.rewardsCalculatorProducts != undefined) {
            return eligibleProducts.value.rewardsCalculatorProducts.filter(product => {
                return product.section === 'Storage+'
            })
        }
    }
})

const calculateRewards = () => {
    totalUnits.value = 0
    totalUsdRewards.value = 0
    pdpUnits.value = 0
    pdpMultiplierUnits.value = 0
    pdpmultiplier.value = 1
    pdpUsdReward.value = 0
    pdpUsdRewardWithMultiplier.value = 0

    serverUnits.value = 0
    serverMultiplierUnits.value = 0
    serverMultiplier.value = 1
    serverUsdReward.value = 0
    serverUsdRewardWithMultiplier.value = 0

    storageUnits.value = 0
    storageMultiplierUnits.value = 0
    storageMultiplier.value = 1
    storageUsdReward.value = 0
    storageUsdRewardWithMultiplier.value = 0

    totalUsdReward.value = 0

    eligibleProducts.value.rewardsCalculatorProducts.forEach((item) => {
        var estUnits = Number(item.estimatedUnits)

        if (estUnits > 0) {
            totalUnits.value = totalUnits.value + estUnits;

            if (item.section === 'PCs + Displays + Peripherals') {
                pdpUnits.value = pdpUnits.value + estUnits

                if (item.countTowardsMultiplier === true) {
                    pdpMultiplierUnits.value = pdpMultiplierUnits.value + estUnits
                }
                pdpUsdReward.value = pdpUsdReward.value + (estUnits * item.rewardsPerBox)
            }

            if (item.section === 'Server+') {
                serverUnits.value = serverUnits.value + estUnits
                serverUsdReward.value = serverUsdReward.value + (estUnits * item.rewardsPerBox)

                if (item.countTowardsMultiplier === true) {
                    serverMultiplierUnits.value = serverMultiplierUnits.value + estUnits
                }
            }

            if (item.section === 'Storage+') {
                storageUnits.value = storageUnits.value + estUnits
                storageUsdReward.value = storageUsdReward.value + (estUnits * item.rewardsPerBox)

                if (item.countTowardsMultiplier === true) {
                    storageMultiplierUnits.value = storageMultiplierUnits.value + estUnits
                }
            }
        }
    })

    // calc multipliers
    // pdp
    if (pdpMultiplierUnits.value >= 30 && pdpMultiplierUnits.value < 80) {
        pdpmultiplier.value = 1.2
    }
    if (pdpMultiplierUnits.value >= 80 && pdpMultiplierUnits.value < 250) {
        pdpmultiplier.value = 1.3
    }
    if (pdpMultiplierUnits.value >= 250 && pdpMultiplierUnits.value < 400) {
        pdpmultiplier.value = 1.5
    }
    if (pdpUnits.value >= 400) {
        pdpmultiplier.value = 1.6
    }

    //server
    if (serverMultiplierUnits.value >= 5 && serverMultiplierUnits.value < 10) {
        serverMultiplier.value = 1.2
    }
    if (serverMultiplierUnits.value >= 10 && serverMultiplierUnits.value < 15) {
        serverMultiplier.value = 1.3
    }
    if (serverMultiplierUnits.value >= 15 && serverMultiplierUnits.value < 20) {
        serverMultiplier.value = 1.5
    }
    if (serverMultiplierUnits.value >= 20) {
        serverMultiplier.value = 1.6
    }

    //storage
    if (storageMultiplierUnits.value >= 2 && storageMultiplierUnits.value < 4) {
        storageMultiplier.value = 1.2
    }
    if (storageMultiplierUnits.value >= 4 && storageMultiplierUnits.value < 8) {
        storageMultiplier.value = 1.3
    }
    if (storageMultiplierUnits.value >= 8 && storageMultiplierUnits.value < 12) {
        storageMultiplier.value = 1.5
    }
    if (storageMultiplierUnits.value >= 12) {
        storageMultiplier.value = 1.6
    }



    pdpUsdRewardWithMultiplier.value = pdpUsdReward.value * pdpmultiplier.value
    serverUsdRewardWithMultiplier.value = serverUsdReward.value * serverMultiplier.value
    storageUsdRewardWithMultiplier.value = storageUsdReward.value * storageMultiplier.value
    totalUsdReward.value = pdpUsdRewardWithMultiplier.value + serverUsdRewardWithMultiplier.value + storageUsdRewardWithMultiplier.value
    totalUsdRewardWithoutMulpiplier.value = pdpUsdReward.value + serverUsdReward.value + storageUsdReward.value
}

const downloadSummary = () => {
    systemStore.showLoading(true)
    var srh = searchProduct.value
    searchProduct.value = ''
    screenshot.value = true
    setTimeout(() => {
        html2canvas(document.querySelector("#summary")).then(function (canvas) {
            systemStore.showLoading(false)
            var dataURL = canvas.toDataURL();
            var timestamp = Number(new Date());
            systemStore.downloadFile(dataURL, 'Rewards_Calculator_Summary_' + timestamp + '.png')

            screenshot.value = false
            searchProduct.value = srh
        });
    }, 100);

}

const headers = [
    { title: 'Line of Business', key: 'section', value: 'section', headerProps: { class: 'v-data-table-header-disti' } },
    { title: 'Product', key: 'productDescription', value: 'productDescription', headerProps: { class: 'v-data-table-header-disti' } },
    { title: 'Counts Towards Rewards Multiplier', value: 'counttowardsmultiplier', headerProps: { class: 'v-data-table-header-disti' } },
    { title: 'Estimated Units', value: 'estimatedunits', headerProps: { class: 'v-data-table-header-disti' } },
    { title: '$ (USD) Per Unit', value: 'rewardsperbox', headerProps: { class: 'v-data-table-header-disti' } },
]


onMounted(() => {


    systemStore.getEligibleProducts().then(result => {
        if (result.success === true) {
            eligibleProducts.value = result
        } else {
            systemStore.showMessage('Error retrieving data, please try again or contact support for assistance.', { color: 'error' })
        }
    }).catch(error => {
        systemStore.showMessage('Error retrieving data, please try again or contact support for assistance.', { color: 'error' })
    })
})



const calculate = () => {
    calculated.value = true
}

</script>

<style>
    .v-data-table-header-disti {
    background-color: #004D40;
    color: #FFFFFF;
    font-size: 0.875rem;
    font-weight: 700;
    }
</style>